import { useRef, useState, useContext } from 'react';

import { NavLink, Link as RouterLink } from 'react-router-dom';

import {
  Avatar,
  Box,
  Button,
  Divider,
  Hidden,
  IconButton,
  lighten,
  List,
  ListItem,
  ListItemText,
  Popover,
  Stack,
  Typography,
  Link
} from '@mui/material';

import InboxTwoToneIcon from '@mui/icons-material/InboxTwoTone';
import { styled } from '@mui/material/styles';
import ExpandMoreTwoToneIcon from '@mui/icons-material/ExpandMoreTwoTone';
import AccountBoxTwoToneIcon from '@mui/icons-material/AccountBoxTwoTone';
import LockOpenTwoToneIcon from '@mui/icons-material/LockOpenTwoTone';
import AccountTreeTwoToneIcon from '@mui/icons-material/AccountTreeTwoTone';
import { Web3AuthContext } from '../../../../contexts/Web3Auth';
import { formatAddress } from '../../../../utils/helperUtils';
import { Icon } from '@iconify/react';

const UserBoxButton = styled(Button)(
  ({ theme }) => `
        padding-left: ${theme.spacing(1)};
        padding-right: ${theme.spacing(1)};
`
);

const MenuUserBox = styled(Box)(
  ({ theme }) => `
        background: ${theme.colors.alpha.black[5]};
        padding: ${theme.spacing(2)};
`
);

const UserBoxText = styled(Box)(
  ({ theme }) => `
        text-align: left;
        padding-left: ${theme.spacing(1)};
`
);

const UserBoxLabel = styled(Typography)(
  ({ theme }) => `
        font-weight: ${theme.typography.fontWeightBold};
        color: ${theme.palette.secondary.main};
        display: block;
`
);

const UserBoxDescription = styled(Typography)(
  ({ theme }) => `
        color: ${lighten(theme.palette.secondary.main, 0.5)}
`
);

function HeaderUserbox() {
  const {
    user: { email, profileImage, name, walletAddress, issuerStatus },
    logout
  } = useContext(Web3AuthContext);

  const ref = useRef<any>(null);
  const [isOpen, setOpen] = useState<boolean>(false);
  const [isCoppied, setIsCoppied] = useState<boolean>(false);

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };
  const onLogOutClick = () => {
    logout();
  };

  const onClickCopyWalletAddress = () => {
    navigator.clipboard.writeText(walletAddress);
    setIsCoppied(true);
    setTimeout(() => {
      setIsCoppied(false);
    }, 5000);
  };
  return (
    <>
      <UserBoxButton color="secondary" ref={ref} onClick={handleOpen}>
        <Avatar variant="rounded" alt={name} src={profileImage} />
        <Hidden mdDown>
          <UserBoxText>
            <UserBoxLabel variant="body1">{name}</UserBoxLabel>
            <UserBoxDescription variant="body2">{email}</UserBoxDescription>
          </UserBoxText>
        </Hidden>
        <Hidden smDown>
          <ExpandMoreTwoToneIcon sx={{ ml: 1 }} />
        </Hidden>
      </UserBoxButton>
      <Popover
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <MenuUserBox sx={{ minWidth: 210 }} display="flex">
          <Avatar variant="rounded" alt={name} src={profileImage} />
          <UserBoxText>
            <UserBoxLabel variant="body1">{name}</UserBoxLabel>
            <UserBoxDescription variant="body2">{email}</UserBoxDescription>
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography variant="body1">
                {formatAddress(walletAddress)}
              </Typography>
              {isCoppied ? (
                <IconButton>
                  <Icon
                    fontSize={24}
                    color="green"
                    icon="fluent:copy-20-regular"
                  />
                </IconButton>
              ) : (
                <IconButton onClick={onClickCopyWalletAddress}>
                  <Icon fontSize={24} icon="fluent:copy-20-regular" />
                </IconButton>
              )}
            </Stack>
          </UserBoxText>
        </MenuUserBox>
        <Divider sx={{ mb: 0 }} />
        <List sx={{ p: 1 }} component="nav">
          {issuerStatus === 'SUCCESS' && (
            <ListItem>
              <Link
                sx={{
                  display: 'flex',
                  gap: 2
                }}
                target="_blank"
                href={`${window.location.origin}/issuer/${walletAddress}`}
              >
                <Icon fontSize={24} icon="healthicons:ui-user-profile" />
                <ListItemText primary="My Issuer Profile" />
              </Link>
            </ListItem>
          )}
          <ListItem>
            <Link
              sx={{
                display: 'flex',
                gap: 2
              }}
              target="_blank"
              href={`${window.location.origin}/user/${walletAddress}`}
            >
              <Icon fontSize={24} icon="healthicons:ui-user-profile-outline" />
              <ListItemText primary="My Certificant Profile" />
            </Link>
          </ListItem>
          {/* <ListItem button to="/dashboards/messenger" component={NavLink}>
            <InboxTwoToneIcon fontSize="small" />
            <ListItemText primary="Messenger" />
          </ListItem>
          <ListItem
            button
            to="/management/profile/settings"
            component={NavLink}
          >
            <AccountTreeTwoToneIcon fontSize="small" />
            <ListItemText primary="Account Settings" />
          </ListItem> */}
        </List>
        <Divider />
        <Box sx={{ m: 1 }}>
          <Button onClick={onLogOutClick} color="primary" fullWidth>
            <LockOpenTwoToneIcon sx={{ mr: 1 }} />
            Sign out
          </Button>
        </Box>
      </Popover>
    </>
  );
}

export default HeaderUserbox;
